// パスワードリセット用のカスタムhooks
import { useState, useCallback } from 'react';
/**
 * パスワード変更のカスタムhooks
 * @param init_state 初期値
 * @returns
 */
export var usePassword = function (init_state) {
    var _a = useState(init_state), state = _a[0], setState = _a[1];
    var handleChange = useCallback(function (event) {
        setState(event.target.value);
    }, [setState]);
    return [state, handleChange];
};
